/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { params } from '../../../../../../redux/reducers/reducer';
import { extrudeSettings } from '../../../../../../utils/Functions';
import { PatternTwoModel } from '../../../ShareModel/PatternModel/PatternTwoModel';
import { WindowModel } from './WindowModel/WindowModel';

const SectionalWithWilliamsburgWindowDoor = ({ width, height, trimWidth, doorColor, glassTexture }) => {

    const deviation = 0.03;
    const defaultWidth = 6;
    const defaultHeight = 6;
    const doorWidth = defaultWidth - trimWidth - deviation * 4;
    const doorHeight = defaultHeight - trimWidth - deviation * 4;
    const holeWidthSize = 1.3;
    const holeHeightSize = 1
    const holeDistanceLimitX = 0.05;
    const holeDistanceLimitY = 0.2;
    const holeAreaSizeW = holeWidthSize + holeDistanceLimitX * 2;
    const holeAreaSizeH = holeHeightSize + holeDistanceLimitY * 2;
    const holeCountX = 4
    const holeCountY = 4
    const holeDistanceX = 0.0359
    const holeDistanceY = 0.036
    const borderLineDistanceY = 1.445

    const trimColor = useMemo(() => {
        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])

    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth,  -height / 2);
        model.lineTo(-width / 2,  -height / 2);
        model.lineTo(-width / 2,  height / 2);
        model.lineTo(width / 2,  height / 2);
        model.lineTo(width / 2,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimWidth);
        model.lineTo(-width / 2 + trimWidth,  height / 2 - trimWidth);
        model.closePath();

        return model
    }, [width, height])

    const doorModel = useMemo(() => {        
        const model = new THREE.Shape();
        model.moveTo(-(defaultWidth / 2 - deviation) + trimWidth,  -(defaultHeight / 2 - deviation));
        model.lineTo(-(defaultWidth / 2 - deviation) + trimWidth,  (defaultHeight / 2) - trimWidth);
        model.lineTo((defaultWidth / 2 - deviation) - trimWidth,  (defaultHeight / 2) - trimWidth);
        model.lineTo((defaultWidth / 2 - deviation) - trimWidth,  -(defaultHeight / 2 - deviation));
        model.closePath();

        for (let i = 1; i <= holeCountX; i++) {
            for (let j = 1; j <= holeCountY ; j++) {
                const hole = new THREE.Path();
                hole.moveTo(-doorWidth / 2 + holeDistanceX * i + holeAreaSizeW * (i - 1) + holeDistanceLimitX,              -doorHeight / 2 + holeDistanceY * j + holeAreaSizeH * (j - 1) + holeDistanceLimitY + holeHeightSize);
                hole.lineTo(-doorWidth / 2 + holeDistanceX * i + holeAreaSizeW * (i - 1) + holeDistanceLimitX,              -doorHeight / 2 + holeDistanceY * j + holeAreaSizeH * (j - 1) + holeDistanceLimitY);
                hole.lineTo(-doorWidth / 2 + holeDistanceX * i + holeAreaSizeW * (i - 1) + holeDistanceLimitX + holeWidthSize,   -doorHeight / 2 + holeDistanceY * j + holeAreaSizeH * (j - 1) + holeDistanceLimitY);
                hole.lineTo(-doorWidth / 2 + holeDistanceX * i + holeAreaSizeW * (i - 1) + holeDistanceLimitX + holeWidthSize,   -doorHeight / 2 + holeDistanceY * j + holeAreaSizeH * (j - 1) + holeDistanceLimitY + holeHeightSize);
                hole.closePath();

                model.holes.push(hole);
            }
        }

        return model;
    
    }, [])

    const insideDoorModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(defaultWidth / 2) + trimWidth,  -(defaultHeight / 2));
        model.lineTo(-(defaultWidth / 2) + trimWidth,  (defaultHeight / 2 - borderLineDistanceY) - trimWidth);
        model.lineTo((defaultWidth / 2) - trimWidth,  (defaultHeight / 2 - borderLineDistanceY) - trimWidth);
        model.lineTo((defaultWidth / 2) - trimWidth,  -(defaultHeight / 2));
        model.closePath();

        return model;
    
    }, [])

    const firstEndHoleWindowModel = useMemo(() => {  
        const deviation = 0.18      
        const model = new THREE.Shape();
        model.moveTo(-((holeWidthSize - 0.06) / 2 - deviation + 0.04), -((holeHeightSize - 0.06) / 2 - deviation));
        model.lineTo(-((holeWidthSize - 0.06) / 2 - deviation + 0.04), ((holeHeightSize - 0.06) / 2 - deviation));
        model.lineTo(((holeWidthSize - 0.06) / 2 - deviation + 0.04), ((holeHeightSize - 0.06) / 2 - deviation));
        model.lineTo(((holeWidthSize - 0.06) / 2 - deviation + 0.04), -((holeHeightSize - 0.06) / 2 - deviation));
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-((holeWidthSize - 0.06) / 2 - deviation - 0.1), -((holeHeightSize - 0.06) / 2 - deviation));
        hole.bezierCurveTo(-((holeWidthSize - 0.06) / 2 - deviation - 0.1), -((holeHeightSize - 0.06) / 2 - deviation),
                            0, ((holeHeightSize - 0.06) / 2 - deviation - 0.1),
                            ((holeWidthSize - 0.06) / 2 - deviation + 0.04 - 0.05), ((holeHeightSize - 0.06) / 2 - deviation - 0.08))
        
        hole.lineTo(((holeWidthSize - 0.06) / 2 - deviation + 0.04 - 0.05), -((holeHeightSize - 0.06) / 2 - deviation));
        hole.closePath();

        model.holes.push(hole);

        return model;
    
    }, [])

    const centerHoleWindowModel = useMemo(() => {  
        const deviation = 0.18      
        const model = new THREE.Shape();
        model.moveTo(-((holeWidthSize - 0.06) / 2 - deviation + 0.04), -((holeHeightSize - 0.06) / 2 - deviation));
        model.lineTo(-((holeWidthSize - 0.06) / 2 - deviation + 0.04), ((holeHeightSize - 0.06) / 2 - deviation));
        model.lineTo(((holeWidthSize - 0.06) / 2 - deviation + 0.04), ((holeHeightSize - 0.06) / 2 - deviation));
        model.lineTo(((holeWidthSize - 0.06) / 2 - deviation + 0.04), -((holeHeightSize - 0.06) / 2 - deviation));
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-((holeWidthSize - 0.06) / 2 - deviation - 0.01), -((holeHeightSize - 0.06) / 2 - deviation));
        hole.lineTo(-((holeWidthSize - 0.06) / 2 - deviation - 0.01), ((holeHeightSize - 0.06) / 2 - deviation - 0.03))
        hole.bezierCurveTo(-((holeWidthSize - 0.06) / 2 - deviation - 0.01), ((holeHeightSize - 0.06) / 2 - deviation - 0.03),
                            0, ((holeHeightSize - 0.06) / 2 - deviation ),
                            ((holeWidthSize - 0.06) / 2 - deviation + 0.04 - 0.05), ((holeHeightSize - 0.06) / 2 - deviation))
        hole.lineTo(((holeWidthSize - 0.06) / 2 - deviation + 0.04 - 0.05), -((holeHeightSize - 0.06) / 2 - deviation - 0.12))                    
        hole.bezierCurveTo(((holeWidthSize - 0.06) / 2 - deviation + 0.04 - 0.05), -((holeHeightSize - 0.06) / 2 - deviation - 0.12),
                            ((holeWidthSize - 0.06) / 2 - deviation + 0.04 - 0.15), -((holeHeightSize - 0.06) / 2 - deviation - 0.13),
                            ((holeWidthSize - 0.06) / 2 - deviation + 0.04 - 0.25), -((holeHeightSize - 0.06) / 2 - deviation))
        hole.closePath();

        model.holes.push(hole);

        return model;
    
    }, [])

    const firstEndConnectBarModel = () => {

        const model = new THREE.Shape();
        model.moveTo(((holeWidthSize - 0.06) / 2 - deviation - 0.15), -((holeHeightSize - 0.06) / 2 - deviation - 0.45))
        model.lineTo(((holeWidthSize - 0.06) / 2 - deviation - 0.15), -((holeHeightSize - 0.06) / 2 - deviation - 0.39))
        model.lineTo(((holeWidthSize - 0.06) / 2 - deviation - 0.15 - 0.5), -((holeHeightSize - 0.06) / 2 - deviation - 0.48))
        model.lineTo(((holeWidthSize - 0.06) / 2 - deviation - 0.15 - 0.42), -((holeHeightSize - 0.06) / 2 - deviation - 0.52))
        model.closePath()
        return model;
    }

    const centerLeftConnectBarModel = () => {

        const model = new THREE.Shape();
        model.moveTo(-((holeWidthSize - 0.06) / 2 - deviation - 0.1), -((holeHeightSize - 0.06) / 2 - deviation - 0.35))
        model.lineTo(-((holeWidthSize - 0.06) / 2 - deviation - 0.1), -((holeHeightSize - 0.06) / 2 - deviation - 0.4))
        model.lineTo(((holeWidthSize - 0.06) / 2 - deviation + 0.04 - 0.25), -((holeHeightSize - 0.06) / 2 - deviation - 0.22))
        model.lineTo(((holeWidthSize - 0.06) / 2 - deviation + 0.04 - 0.2), -((holeHeightSize - 0.06) / 2 - deviation - 0.16))
        model.closePath()
        return model;
    }

    const centerRightConnectBarModel = () => {

        const model = new THREE.Shape();
        model.moveTo(-((holeWidthSize - 0.06) / 2 - deviation - 0.3), ((holeHeightSize - 0.06) / 2 - deviation - 0.15 ))
        model.lineTo(-((holeWidthSize - 0.06) / 2 - deviation - 0.4), ((holeHeightSize - 0.06) / 2 - deviation - 0.15))
        model.lineTo(((holeWidthSize - 0.06) / 2 - deviation + 0.04 - 0.15), -((holeHeightSize - 0.06) / 2 - deviation - 0.22))
        model.lineTo(((holeWidthSize - 0.06) / 2 - deviation + 0.04 - 0.17), -((holeHeightSize - 0.06) / 2 - deviation - 0.16))
        model.closePath()
        return model;
    }
    
    const glassTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-holeWidthSize / 2, holeHeightSize / 2);
        model.lineTo(-holeWidthSize / 2, -holeHeightSize / 2);
        model.lineTo(holeWidthSize / 2, -holeHeightSize / 2);
        model.lineTo(holeWidthSize / 2, holeHeightSize / 2);
        model.closePath();
        
        const hole = new THREE.Path();
        hole.moveTo(-(holeWidthSize / 2 - 0.001), -(holeHeightSize / 2 - 0.001));
        hole.lineTo(-(holeWidthSize / 2 - 0.001), (holeHeightSize / 2 - 0.001));
        hole.lineTo((holeWidthSize / 2 - 0.001), (holeHeightSize / 2 - 0.001));
        hole.lineTo((holeWidthSize / 2 - 0.001), -(holeHeightSize / 2 - 0.001));
        hole.closePath();

        model.holes.push(hole);

        return model;
    }, [holeWidthSize, holeHeightSize])
    
    return (
        <group scale={[defaultWidth / 6, defaultHeight / 6, 1]}>
            <mesh name='trim'>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <group scale={[(width - 0.2) / 5.8, (height - 0.1) / 5.9, 1]} >
                <mesh name='pattern-models' position={[0, 0, 0.05]}>
                    <extrudeGeometry args={[doorModel, extrudeSettings(0.2, 0.03, 0.03, 0, 2)]} />
                    <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                </mesh>
                <mesh name='pattern-models' position={[0, 0, 0.145]}>
                    <extrudeGeometry args={[insideDoorModel, extrudeSettings(0.01)]} />
                    <meshStandardMaterial color={doorColor} side={THREE.DoubleSide} metalness={0.3} />
                </mesh>
                
                {new Array(2).fill("").map((_, indexI) =>
                    new Array(holeCountY - 1).fill("").map((_, indexJ) =>
                        <mesh key={`border-line-${indexI}-${indexJ}`} name='pattern-border-line-models' position={[0, -doorHeight / 2 + borderLineDistanceY * (indexJ + 1), 0.02 + 0.25 * indexI]} rotation={[0, 0, Math.PI / 2]}>
                            <cylinderGeometry args={[0.02, 0.02, (defaultWidth - trimWidth * 2), 15, 1]} />
                            <meshStandardMaterial color={doorColor} side={THREE.DoubleSide} metalness={0.3} />
                        </mesh>
                    )
                )}
                
                {new Array(holeCountX).fill("").map((_, indexI) =>
                    new Array(holeCountY - 1).fill("").map((_, indexJ) => 
                        <group key={`pattern-model-${indexI}-${indexJ}`} name='pattern-models' position={[
                            -doorWidth / 2 + holeDistanceX * (indexI + 1) + holeAreaSizeW / 2 + holeAreaSizeW * indexI,
                            -doorHeight / 2 + holeDistanceY * (indexJ + 1) + holeAreaSizeH / 2 + holeAreaSizeH * indexJ,
                            0.14]}
                        >
                            <PatternTwoModel modelWidth={holeWidthSize} modelHeight={holeHeightSize} doorColor={doorColor}  />
                        </group>
                    )
                )}

                {new Array(holeCountX).fill("").map((_, index) =>
                        <mesh key={`glass-trim-model-${index}`} name='pattern-models' position={[
                            -doorWidth / 2 + holeDistanceX * (index + 1) + holeAreaSizeW / 2 + holeAreaSizeW * index,
                            -doorHeight / 2 + holeDistanceY * (holeCountY) + holeAreaSizeH / 2 + holeAreaSizeH * (holeCountY - 1),
                            0.14]}
                        >
                            <extrudeGeometry args={[glassTrimModel, extrudeSettings(0.01, 0.14, 0.14, 0, 1)]} />
                            <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                        </mesh>
                )}     

                {new Array(holeCountX).fill("").map((_, indexI) =>
                        <group key={`pattern-model-${indexI}`} name='pattern-models' position={[
                            -doorWidth / 2 + holeDistanceX * (indexI + 1) + holeAreaSizeW / 2 + holeAreaSizeW * indexI,
                            -doorHeight / 2 + holeDistanceY * (holeCountY ) + holeAreaSizeH / 2 + holeAreaSizeH * (holeCountY - 1),
                            0.14]}
                        >
                            <WindowModel modelWidth={holeWidthSize - 0.06} modelHeight={holeHeightSize - 0.06} doorColor={doorColor}  glassTexture={glassTexture} />
                        </group>
                )}

               <>
                    {new Array(2).fill("").map((_, index) =>
                            <group position={[
                                -doorWidth / 2 + holeDistanceX * (index * 3 + 1)  + holeAreaSizeW / 2 + holeAreaSizeW * index * 3,
                                -doorHeight / 2 + holeDistanceY * (holeCountY ) + holeAreaSizeH / 2 + holeAreaSizeH * (holeCountY - 1),
                                0.14]} rotation={[0, Math.PI * index, 0]}
                            >
                                <mesh name='pattern-models' position={[0, 0, -0.13]}>
                                    <extrudeGeometry args={[firstEndHoleWindowModel, extrudeSettings(0.28)]} />
                                    <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                                    </mesh>
                            </group>
                    )}
                    {new Array(2).fill("").map((_, index) =>
                        <group position={[
                            -doorWidth / 2 + holeDistanceX * (index + 2) + holeAreaSizeW / 2 + holeAreaSizeW * (index + 1),
                            -doorHeight / 2 + holeDistanceY * (holeCountY ) + holeAreaSizeH / 2 + holeAreaSizeH * (holeCountY - 1),
                            0.14]} rotation={[0, Math.PI * index, 0]}
                        >
                            <mesh name='pattern-models' position={[0, 0, -0.13]}>
                                <extrudeGeometry args={[centerHoleWindowModel, extrudeSettings(0.28)]} />
                                <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                                </mesh>
                        </group>
                    )}

                    {new Array(2).fill("").map((_, index) =>
                            <group position={[
                                -doorWidth / 2 + holeDistanceX * (index * 3 + 1) + holeAreaSizeW / 2 + holeAreaSizeW * index * 3,
                                -doorHeight / 2 + holeDistanceY * (holeCountY ) + holeAreaSizeH / 2 + holeAreaSizeH * (holeCountY - 1),
                                0.14]} rotation={[0, Math.PI * index, 0]}
                            >
                                <mesh name='pattern-models' position={[0, 0, -0.13]}>
                                    <extrudeGeometry args={[firstEndConnectBarModel(), extrudeSettings(0.28)]} />
                                    <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                                </mesh>
                            </group>
                    )}

                    {new Array(2).fill("").map((_, index) =>
                        <group position={[
                            -doorWidth / 2 + holeDistanceX * (index + 2) + holeAreaSizeW / 2 + holeAreaSizeW * (index + 1),
                            -doorHeight / 2 + holeDistanceY * (holeCountY ) + holeAreaSizeH / 2 + holeAreaSizeH * (holeCountY - 1),
                            0.14]} rotation={[0, Math.PI * index, 0]}
                        >
                            <mesh name='pattern-models' position={[0, 0, -0.13]}>
                                <extrudeGeometry args={[centerLeftConnectBarModel(), extrudeSettings(0.28)]} />
                                <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                                </mesh>
                        </group>
                    )}
                    {new Array(2).fill("").map((_, index) =>
                        <group position={[
                            -doorWidth / 2 + holeDistanceX * (index + 2) + holeAreaSizeW / 2 + holeAreaSizeW * (index + 1),
                            -doorHeight / 2 + holeDistanceY * (holeCountY ) + holeAreaSizeH / 2 + holeAreaSizeH * (holeCountY - 1),
                            0.14]} rotation={[0, Math.PI * index, 0]}
                        >
                            <mesh name='pattern-models' position={[0, 0, -0.13]}>
                                <extrudeGeometry args={[centerRightConnectBarModel(), extrudeSettings(0.28)]} />
                                <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                            </mesh>
                        </group>
                    )}
                </>
            </group>
        </group>
    )
}

export default SectionalWithWilliamsburgWindowDoor
